const BASEURL = 'https://admin.wineye.com/'   //'https://admin.wineye-dev.tk/' //https://admin.wineye.com/   //https://adminsandbox.uk/    //http://localhost:3100/  //https://admin.wineye.com/ production
const WEBSTORE_BASEURL = 'https://shop.wineye.com/'  //https://wineye-dev.tk/   // https://shop.wineye.com/
const CRONJOB_BASEURL = 'https://cron.wineye.com/'   //https://cron.wineye-dev.tk/    // https://cron.wineye.com/
const WebBASEURL = 'https://admin.wineye.com/'     //'https://admin.wineye-dev.tk/'   //https://admin.wineye.com/
export {
    BASEURL,
    WebBASEURL,
    WEBSTORE_BASEURL,
    CRONJOB_BASEURL
}